module.exports = __webpack_public_path__ + "img/fuel-injection-schematic-light.0f9881f1.png";